export const DEFAULT_COUNTS_TOWARD_USAGE = true;
const COUNTS_TOWARD_USAGE_STORAGE_KEY = 'pendingCreationCountsTowardUsage';

type SupportCountsTowardUsageDialogOptions = {
  context: {
    modal: {
      show: (
        content?: Record<string, unknown> | null,
        callback?: ((form?: unknown, res?: unknown) => void) | null
      ) => void;
    };
  };
  entityLabel: string;
  onContinue?: (countsTowardUsage: boolean) => void;
  defaultCountsTowardUsage?: boolean;
  disableCountTowardUsage?: boolean;
};

export function storePendingCountsTowardUsage(countsTowardUsage: boolean = DEFAULT_COUNTS_TOWARD_USAGE): void {
  sessionStorage.setItem(COUNTS_TOWARD_USAGE_STORAGE_KEY, JSON.stringify(Boolean(countsTowardUsage)));
}

export function getPendingCountsTowardUsage(fallback: boolean = DEFAULT_COUNTS_TOWARD_USAGE): boolean {
  const rawValue = sessionStorage.getItem(COUNTS_TOWARD_USAGE_STORAGE_KEY);
  if (rawValue == null) {
    return fallback;
  }
  try {
    const parsedValue: unknown = JSON.parse(rawValue);
    return typeof parsedValue === 'boolean' ? parsedValue : fallback;
  } catch {
    return fallback;
  }
}

export function clearPendingCountsTowardUsage(): void {
  sessionStorage.removeItem(COUNTS_TOWARD_USAGE_STORAGE_KEY);
}

export function openSupportCountsTowardUsageDialog({
  context,
  entityLabel,
  onContinue,
  defaultCountsTowardUsage = DEFAULT_COUNTS_TOWARD_USAGE,
  disableCountTowardUsage = false,
}: SupportCountsTowardUsageDialogOptions): void {
  const defaultValue = defaultCountsTowardUsage ? 'true' : 'false';
  const options = disableCountTowardUsage
    ? [
        { value: 'false', label: 'No, exclude it' },
        { value: 'true', label: 'Yes, count it', disabled: true },
      ]
    : [
        { value: 'true', label: 'Yes, count it' },
        { value: 'false', label: 'No, exclude it' },
      ];

  context.modal.show(
    {
      title: 'Usage / limits',
      text: `Should this ${entityLabel} count toward usage / limits?`,
      form: {
        countsTowardUsage: {
          type: 'radio',
          value: defaultValue,
          options,
          cols: 1,
        },
      },
      buttonText: 'Continue',
      customSubmit: async (data?: { countsTowardUsage?: string }) => ({
        countsTowardUsage: data?.countsTowardUsage === 'false' ? false : true,
      }),
    },
    (_form, result) => {
      if (typeof onContinue === 'function') {
        const countsTowardUsage = (result as { countsTowardUsage?: boolean } | null | undefined)?.countsTowardUsage;
        onContinue(countsTowardUsage === false ? false : true);
      }
    }
  );
}
